export var COMMON_TRANSLATIONS = {
    commons: {
        continue: 'Continuar',
        cancel: 'Cancelar',
        save: 'Manter',
        edit: 'Editar informações',
        digits: 'dígitos',
        characters: 'caracteres',
        fields: {
            errors: {
                required: 'Campo obrigatório',
                email: 'E-mail inválido',
                phone: 'Telefone inválido',
                minLenght: 'Deve conter no mínimo {{min}} {{type}}',
                maxLenght: 'Deve conter no máximo {{max}} {{type}}',
                minMaxLength: 'Deve conter entre {{min}} e {{max}} {{type}}',
                length: 'Deve conter exatamente {{length}} {{type}}',
                onlyDigits: 'Deve conter apenas números',
                invalidFormat: 'Formato inválido',
            },
        },
        buttons: {
            next: 'Próximo',
            previous: 'Antigo',
            accept: 'Aceitar',
            cancel: 'Cancelar',
        },
        files: {
            dropLabel: 'Solte o arquivo aqui',
            label: {
                default: 'Arraste o arquivo aqui ou',
                generating: 'Gerando menu com IA...',
                success: 'Menu gerado',
                error: 'Erro na geração',
            },
            description: {
                generating: 'Este processo pode levar até 5 minutos.',
                success: 'Revise para concluir a configuração.',
            },
            button: {
                replace: 'Substituir',
                select: 'Selecionar',
            },
            rules: {
                format: 'Formato',
                size: 'Tamanho',
            },
            errors: {
                noSupport: 'Arquivo não suportado!',
                encrypted: 'Arquivo criptografado',
                format: 'Formato de arquivo não permitido',
                maxSize: 'Tamanho máximo do arquivo excedido',
                merge: 'Erro ao mesclar os arquivos',
            },
        },
        errors: {
            communication: 'Erro de comunicação, tente novamente',
        },
    },
};
